import React from "react";
import { Link } from "react-router-dom";
import "./HistoriaNosotros.css";


const HistoriaNosotros = () => {

    const handleNavegar = () => {
        window.location.href = "/productos";
    }

    return (
        <section className="historia-nosotros">
            <div className="container">
                <div className="row align-items-start g-4">
                    <div className="col-lg-4 col-md-6 col-12 historia-imagenes">
                        <img src="/img/nosotros/barman-with-cocktail.jpg" alt="Barman preparando un cocktail" className="img-fluid" />
                        <img src="/img/nosotros/basoDeWhisky.webp" alt="Vaso de whisky" className="img-fluid segundaImg" />
                    </div>

                    {/* 📌 Texto */}
                    <div className="col-lg-8 col-md-6 col-12 historia-contenido">
                        <h2>En W&Co.</h2>
                        <p>
                            La pasión, los buenos momentos y la tradición de las destilerías nos llevó a proyectar un lugar exclusivo a entusiastas y amantes del whisky.
                        </p>
                        <h3>Misión</h3>
                        <p>
                        Ofrecemos una amplia selección de whiskys de distintos continentes, desde las destilerías más antiguas y renombradas del mundo hasta aquellas que están en sus inicios. <br/>
                        Brindamos un lugar para eventos privados, catas y un espacio donde acercarte y disfrutar de un vaso de whisky. 
                        </p>
                        <h3>Nuestros Objetivos</h3>
                        <ul>
                            <li> Ampliar continuamente la oferta de whiskys y ediciones limitadas. </li>
                            <li> Promover el descubrimiento y la innovación. </li>
                            <li> Fomentar la cultura del whisky a través de iniciativas locales.</li>
                        </ul>
                        <Link to="/productos" className="historia-btn">
                            Descubrí nuestra selección
                        </Link>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default HistoriaNosotros;
